import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pure pipe for converting "YYYYMMDD" date strings to JavaScript Date objects.
 * Angular caches pure pipes — unlike the getDate() method call in templates,
 * this will only re-evaluate when the input value actually changes.
 *
 * Usage: {{ row.date | toDate | date:dateFormat }}
 */
@Pipe({
  name: 'toDate',
  pure: true
})
export class ToDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): Date | null {
    if (value == null) return null;
    if (value instanceof Date) return value;
    if (typeof value !== 'string' || value.trim() === '') return null;
    const s = value.trim();
    const year = +s.substring(0, 4);
    const month = +s.substring(4, 6) - 1; // JS months are 0-indexed
    const day = +s.substring(6);
    return new Date(year, month, day);
  }
}
